<div class="td-card td-pyramid-card">
  <span class="td-card-title">{{ 'td_pyramid_title' | translate }}</span>
  <div class="td-pyramid-body">
    <app-categories-pyramid-display
      [categories]="categories"
      [legend]="legend"
      (categorySelected)="onCategorySelected($event)">
    </app-categories-pyramid-display>
    <span class="td-pyramid-empty" *ngIf="!categories.length">{{ 'td_no_data' | translate }}</span>
  </div>
</div>
